export enum HumanDateFormatType {
  Long = 'long',
  Short = 'short',
  ShortAt = 'shortAt',
  ShortWithSeconds = 'shortWithSeconds',
  TimeOnly = 'timeOnly',
  DateOnly = 'dateOnly',
  DayHumanizedMonth = 'dayHumanizedMonth',
  DayOnly = 'dayOnly',
  HourOnly = 'hourOnly',
  DateWithShortMonth = 'dateWithShortMonth',
  DateLongMonth = 'dateLongMonth',
  DayLongMonth = 'dayLongMonth',
  DateTimeShort = 'dateTimeShort',
  ChatToday = 'chatToday',
  ChatWeek = 'chatWeek',
  ChatFull = 'chatFull',
}
